import { PartLinkTypes, IssueStatuses } from '~/app/data/statuses/issue';
import { ServiceStatuses } from '~/app/data/statuses/services';
import { WorkOrderStatuses } from '~/workorder/types';

export type EntityStoreKey = 'issue' | 'service' | 'workOrder';

export const getEntityStoreKey = (type: PartLinkTypes): EntityStoreKey => {
  if (type === PartLinkTypes.ISSUE) {
    return 'issue';
  }
  if (type === PartLinkTypes.SERVICE) {
    return 'service';
  }
  return 'workOrder';
};

export const isEntityEditable = (
  type: PartLinkTypes,
  status: string | number | undefined
): boolean => {
  if (type === PartLinkTypes.ISSUE) {
    return status === IssueStatuses.REGISTERED;
  }
  if (type === PartLinkTypes.SERVICE) {
    return status === ServiceStatuses.TRIGGERED;
  }
  if (type === PartLinkTypes.WORKORDER) {
    return status !== WorkOrderStatuses.APPROVED;
  }
  return false;
};
